'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactShare = require('react-share');

var _SocialProviderButton = require('../SocialProviderButton');

var _SocialProviderButton2 = _interopRequireDefault(_SocialProviderButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PROVIDER = 'facebook';

var FacebookShare = function (_Component) {
  _inherits(FacebookShare, _Component);

  function FacebookShare() {
    _classCallCheck(this, FacebookShare);

    return _possibleConstructorReturn(this, (FacebookShare.__proto__ || Object.getPrototypeOf(FacebookShare)).apply(this, arguments));
  }

  _createClass(FacebookShare, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          buttonText = _props.buttonText,
          shareText = _props.shareText;

      return _react2.default.createElement(
        _reactShare.FacebookShareButton,
        { url: url, quote: shareText },
        _react2.default.createElement(_SocialProviderButton2.default, { provider: PROVIDER, text: buttonText })
      );
    }
  }]);

  return FacebookShare;
}(_react.Component);

FacebookShare.propTypes = {
  url: _propTypes2.default.string.isRequired,
  buttonText: _propTypes2.default.string.isRequired,
  shareText: _propTypes2.default.string.isRequired
};

exports.default = FacebookShare;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/ShareButtons/FacebookShareButton.js
// module id = 611
// module chunks = 0